<script setup>
import { computed, inject } from 'vue';

const ACTIONS_CONF = {
  buscar: {
    icono: 'search',
    label: 'Buscar',
    disabledWithLabel: 'buscando',
  },
  eliminar: {
    icono: 'trash',
    label: 'Eliminar',
    disabledWithLabel: 'procesando',
  },
  guardar: {
    icono: 'save',
    label: 'Guardar',
    disabledWithLabel: 'guardando',
  },
  importar: {
    icono: 'file-import',
    label: 'Importar',
    disabledWithLabel: 'importando',
  },
};

const props = defineProps({
  disabled: { type: Boolean, default: false },
  // true cuando estén haciendo el submit y se desactiva el botón con
  // el texto indicado en disable-with
  submitting: { type: Boolean, default: false },
  label: { type: [String, Boolean], default: undefined },
  // variant es cifra, default, info etc
  variant: { type: String, default: undefined },
  disableWith: { type: String, default: undefined },
  action: { type: String, default: 'guardar' },
});

const $I18n = inject('I18n');

const disableButton = computed(() => props.disabled || props.submitting);
const variantClass = computed(() => {
  let variante = props.variant;
  if (!variante) {
    if (props.action === 'eliminar') {
      variante = 'danger';
    }
  }
  variante = variante || 'cifra';
  return `btn-${variante}`;
});
const buttonType = computed(() => {
  if (props.action === 'eliminar') {
    return 'button';
  }

  return 'submit';
});

function defaultLabel() {
  const { icono, label } = ACTIONS_CONF[props.action];
  let texto = `<i class="fa fa-${icono}"></i>`;
  if (props.label !== false) {
    texto = `${texto} ${$I18n.t(label)}`;
  }
  return texto;
}

function defaultDisabledWith() {
  const icono = '<i class="fa fa-circle-notch fa-spin"></i>';
  const { disabledWithLabel } = ACTIONS_CONF[props.action];

  return `${icono} ${$I18n.t(disabledWithLabel)}...`;
}
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <button
    :disabled="disableButton"
    :class="`btn ${variantClass}`"
    :type="buttonType"
  >
    <slot v-if="submitting" name="submitting">
      <span v-html="disableWith || defaultDisabledWith()"></span>
    </slot>
    <slot v-else>
      <span v-html="label || defaultLabel()"></span>
    </slot>
  </button>
</template>
